import styled from 'styled-components'
import { breakpoints } from '../../../../constants'
import { WHITE, STRONGORANGE } from '../../../../styles/colors.style'

import LittleCard from '../../../../../assets/images/banners-cartao/mini-card.png'

export const MiniCard = styled.div`
	position: fixed;
	right: 0;
	align-items: center;
	z-index: 3;
	bottom: 0;

	@media (min-width: ${breakpoints.MOBILE}px) {
		display: flex;
		top: 50%;
	}
`

export const Card = styled.div`
	border: 1px solid #ffb759;
    border-radius: 7px;
	text-indent: -9000em;
	overflow: hidden;
	cursor: pointer;
	background: url(${LittleCard}) no-repeat;
	background-size: cover;
	height: 102px;
	width: 153px;
	display: flex;
	align-items: center;
`

export const Register = styled.div`
	background: ${STRONGORANGE};
	width: 182px;
	height: 61px;
	border-radius: 20px 0px 0 20px;
	transition: 0.4s ease-in;
	transform: translate(100%, 0);
	position: absolute;
	z-index: -1;
	transform: translate(-98%, 0);
	a {
		color: ${WHITE};
		text-transform: uppercase;
		font-weight: bold;
		font-size: 18px;
		line-height: 24px;
		margin: 5px 10px 0 0;
		width: 155px;
		display: block;
		text-align: right;
		float: right;
	}
`
